export const SUPABASE_SESSION_EXPIRED = 'supabaseSessionExpired';
export const SUPABASE_USER_FORBIDDEN = 'supabaseUserForbidden';
export const OAUTH_SESSION_EXPIRED = 'oauthSessionExpired';
